import { useEffect, useMemo } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three'
import { useTrackController } from './useTrackController'
import { createTrackGeo } from './trackMeshBuilder'
import { TrackVisibilityController } from './TrackVisibilityController'
import { gltfAsset, textureAssetCompressed } from '../../assetStore'
import { disposeObject } from '../../../utils/threeDisposal'
import { useCompressedTexture } from '../../ktx2Textures'
export { applyTrackMeshEndDistance } from './trackMeshBuilder'

export function Track() {
    const { scene } = useGLTF(gltfAsset.Track)
    const trackController = useTrackController()

    const region1 = useCompressedTexture(textureAssetCompressed.Track_Region_1)
    const region2 = useCompressedTexture(textureAssetCompressed.Track_Region_2)
    const region3 = useCompressedTexture(textureAssetCompressed.Track_Region_3)
    const region4 = useCompressedTexture(textureAssetCompressed.Track_Region_4)
    const transition = useCompressedTexture(textureAssetCompressed.Track_Transition)

    configureTrackTexture(region1)
    configureTrackTexture(region2)
    configureTrackTexture(region3)
    configureTrackTexture(region4)
    configureTrackTexture(transition)

    const trackGeo = useMemo(
        () => createTrackGeo(
            scene,
            { region1, region2, region3, region4, transition },
            trackController,
        ),
        [
            scene,
            region1,
            region2,
            region3,
            region4,
            transition,
            trackController,
        ],
    )
    useEffect(() => {
        return () => {
            disposeObject(trackGeo)
        }
    }, [trackGeo])

    return (
        <>
            <primitive object={trackGeo} />
            <TrackVisibilityController trackGeo={trackGeo} />
        </>
    )
}

function configureTrackTexture(texture: THREE.Texture) {
    texture.wrapS = THREE.RepeatWrapping
    texture.wrapT = THREE.RepeatWrapping
    texture.flipY = false
    texture.colorSpace = THREE.SRGBColorSpace
}
function useCopressedTexture(arg0: ("/textures/track-region-1.png" | "/textures/track-region-2.png" | "/textures/track-region-3.png" | "/textures/track-region-4.png" | "/textures/track-transition.png")[]): [any, any, any, any, any] {
    throw new Error('Function not implemented.')
}

